module.exports = __webpack_public_path__ + "static/media/export.42409d4f.png";